import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';

import LazyLoader from 'components/atoms/Loaders/LazyLoader';

const LazyRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Suspense fallback={<LazyLoader />}>
        <Component {...props} />
      </Suspense>
    )}
  />
);

export default LazyRoute;
